var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edit_note"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_14462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_14462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_note_2",
    d: "M8.3335 23.3333V21.6666H20.0002V23.3333H8.3335ZM8.3335 16.6666V14.9999H26.6668V16.6666H8.3335ZM8.3335 9.99992V8.33325H26.6668V9.99992H8.3335ZM22.0514 31.6666V27.9841L30.9393 19.1378C31.1038 18.9731 31.2735 18.862 31.4485 18.8045C31.6235 18.7467 31.7985 18.7178 31.9735 18.7178C32.1643 18.7178 32.3518 18.7537 32.536 18.8253C32.7204 18.8967 32.8879 19.0041 33.0385 19.1474L34.5802 20.7212C34.7171 20.8856 34.8213 21.0566 34.8927 21.2341C34.9643 21.4113 35.0002 21.5885 35.0002 21.7658C35.0002 21.9433 34.966 22.1223 34.8977 22.3028C34.8293 22.4834 34.7235 22.6559 34.5802 22.8203L25.7343 31.6666H22.0514ZM23.526 30.1924H25.1093L30.8881 24.4037L30.106 23.612L29.3464 22.7978L23.526 28.6091V30.1924ZM30.106 23.612L29.3464 22.7978L30.8881 24.4037L30.106 23.612Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCreate);
export default __webpack_public_path__ + "static/media/sidebar_create.1f6bf89225f2c8d40bf08fade76c8524.svg";
export { ForwardRef as ReactComponent };